"use client";

import { c as _c } from "react/compiler-runtime";
import { ColorModeContext } from "@contexts/color-mode";
import type { ThemePreference } from "@contexts/color-mode/theme-preference";
import { Button } from "@components/ui/styled-button";
import { DropdownV2 } from "@components/ui/DropdownV2";
import { Monitor, Moon, Sun } from "lucide-react";
import { useContext, useMemo } from "react";
const themeOptions: {
  key: ThemePreference;
  label: string;
}[] = [{
  key: "system",
  label: "System"
}, {
  key: "light",
  label: "Light"
}, {
  key: "dark",
  label: "Dark"
}];
export function ThemeToggle() {
  const $ = _c(10);
  const {
    mode,
    preference,
    setPreference
  } = useContext(ColorModeContext);
  let t0;
  if ($[0] !== preference || $[1] !== setPreference) {
    t0 = themeOptions.map(option => ({
      key: option.key,
      label: <span className={preference === option.key ? "font-semibold text-primary" : ""}>{option.label}</span>,
      onClick: () => setPreference(option.key)
    }));
    $[0] = preference;
    $[1] = setPreference;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const menuItems = t0;
  const TriggerIcon = preference === "system" ? Monitor : mode === "dark" ? Moon : Sun;
  let t1;
  if ($[3] !== menuItems) {
    t1 = {
      items: menuItems
    };
    $[3] = menuItems;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== TriggerIcon) {
    t2 = <Button variant="text" aria-label="Change appearance" className="!flex !size-[42px] !items-center !justify-center !p-0" icon={<TriggerIcon className="size-5 text-foreground" />} />;
    $[5] = TriggerIcon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <DropdownV2 menu={t1} align="end">{t2}</DropdownV2>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}